import { Row } from 'antd'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import _, { capitalize } from 'lodash'
import * as React from 'react'

import AttachmentList from '../Attachment/List'
import { CollectionProps } from '../convention'

type Props = {
  onItemClick?: (attachment: IAttachment) => void
}

const List: React.FC<CollectionProps<IAttachment, Props>> = ({
  collection = [],
  props: { onItemClick } = {}
}) => {
  const packages = _.chain(collection || [])
    .groupBy('package.name')
    .map((value, key) => ({
      name: key,
      attachments: value
    }))
    .value()

  return (
    <Row gutter={[0, 24]} className="mobile-spacing">
      {packages.map((packageItem, index) => (
        <KCol span={24} key={index}>
          <Row gutter={[0, 12]}>
            <KCol span={24}>
              <span className="text-muted px-3">{capitalize(packageItem.name)}</span>
            </KCol>
            <KCol span={24}>
              <AttachmentList collection={packageItem.attachments} props={{ onItemClick }} />
            </KCol>
          </Row>
        </KCol>
      ))}
    </Row>
  )
}

export default List
